exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-html5-video]{position:absolute;height:100%;width:100%;display:block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/html5_video/public/style.scss
 ** module id = 133
 ** module chunks = 0
 **/